/**
 * Page de confirmation de la période d'essai gratuite.
 * L'utilisateur arrive ici en cliquant sur le lien reçu par email.
 */
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FaCrown, FaCheck, FaExclamationTriangle } from 'react-icons/fa';
import { ROUTES, API_BASE_URL } from '../config/constants';
import '../styles/Home.css';
import '../styles/TrialConfirmPage.css';

function TrialConfirmPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      setIsLoading(false);
      setError('Lien invalide : token manquant.');
      return;
    }
    const confirmTrial = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/premium/trial/confirm`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await response.json().catch(() => ({}));
        setIsLoading(false);
        if (data.success) {
          setSuccess(true);
          setTimeout(() => navigate(ROUTES.DASHBOARD), 3000);
        } else {
          setError(data.error || 'Impossible d\'activer l\'essai gratuit.');
        }
      } catch (err) {
        setIsLoading(false);
        setError('Erreur de connexion. Réessayez plus tard.');
      }
    };
    confirmTrial();
  }, [token, navigate]);

  if (isLoading) {
    return (
      <div className="trial-confirm-page">
        <div className="trial-confirm-card">
          <FaCrown className="trial-confirm-icon trial-confirm-icon--loading" aria-hidden />
          <h1>Activation en cours...</h1>
          <p>Veuillez patienter.</p>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="trial-confirm-page">
        <div className="trial-confirm-card trial-confirm-card--success">
          <FaCheck className="trial-confirm-icon trial-confirm-icon--success" aria-hidden />
          <h1>Essai activé !</h1>
          <p>Votre période d'essai de 30 jours est maintenant active. Redirection vers le tableau de bord...</p>
          <button type="button" className="trial-confirm-button" onClick={() => navigate(ROUTES.DASHBOARD)}>
            Aller au tableau de bord
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="trial-confirm-page">
      <div className="trial-confirm-card trial-confirm-card--error">
        <FaExclamationTriangle className="trial-confirm-icon trial-confirm-icon--error" aria-hidden />
        <h1>Lien invalide ou expiré</h1>
        <p>{error}</p>
        <p>Vous pouvez demander un nouvel email depuis le tableau de bord.</p>
        <button type="button" className="trial-confirm-button" onClick={() => navigate(ROUTES.DASHBOARD)}>
          Retour au tableau de bord
        </button>
      </div>
    </div>
  );
}

export default TrialConfirmPage;
